import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CreatepackagePage } from './createpackage.page';

const routes: Routes = [
  {
    path: '',
    component: CreatepackagePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreatepackagePageRoutingModule {}
